const ForecastJobType = {
    summary: 'summary',
    forecast: 'forecast'
};

module.exports = Object.freeze(ForecastJobType);